var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "cardSlider" },
    _vm._l(_vm.cards, function(card) {
      return _c("div", { key: card.id }, [
        _c("div", { staticClass: "bg-white p-24 " }, [
          _c(
            "div",
            {
              staticClass: "text-orange text-22 mb-16 font-bold tracking-tight"
            },
            [_vm._v(_vm._s(card.title))]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "rte",
            domProps: { innerHTML: _vm._s(card.description) }
          })
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }